import { SortTimelineItemsArgs } from '@modules/timetable';
import { TimelineItemModelType } from '@models/TimelineItem';

export const sortTimelineItems = ({ timelineItems }: SortTimelineItemsArgs): TimelineItemModelType[] => {
  return timelineItems.sort((itemA, itemB) => {
    if (itemA.startTime < itemB.startTime) {
      return -1;
    }

    if (itemA.startTime > itemB.startTime) {
      return 1;
    }

    return 0;
  });
};
